<template>
  <transition-group name="fade" tag="div" class="spinner" appear>
    <v-progress-circular
      key="progress-circular"
      :size="size"
      :width="width"
      color="#da2a4c"
      indeterminate
    />
  </transition-group>
</template>

<script>
export default {
  name: 'AllOutSpinner',
  props: {
    size: {
      type: Number,
      default: 70
    },
    width: {
      type: Number,
      default: 7
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.spinner {
  display: flex;
  justify-content: center;
  align-items: center;
}

.fade-enter-active {
  transition: opacity 4s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
